import { TTag } from 'components/Tag/Tag.types';
import STag from 'components/Tag/Tag.style';
import React, { FC } from 'react';

const Tag: FC<TTag> = (props: TTag) => {
  return <STag {...props} />;
};

export default Tag;
